package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.repository.UserRepository
import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class UpdateWorkplaceNameUseCase(
    private val workplaceRepository: WorkplaceRepository,
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(workplaceId: String, newName: String): Result<Unit> {
        return try {
            // 1. Zaktualizuj nazwę w samym lokalu
            workplaceRepository.updateWorkplaceName(workplaceId, newName).getOrThrow()

            // 2. Synchronizuj nazwę w engagements użytkowników, którzy tam pracują
            // To jest optymalizacja odczytu dla Dashboardu
            // Pobieramy wszystkich pracowników tego lokalu
            val employees = userRepository.getAssignableEmployees(workplaceId).getOrThrow()

            employees.forEach { user ->
                userRepository.updateCachedWorkplaceName(user.uid, workplaceId, newName)
            }

            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}